"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Departure = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Departure = function Departure(_ref) {
  var scheduledTimeOfDeparture = _ref.scheduledTimeOfDeparture,
      realTimeOfDeparture = _ref.realTimeOfDeparture,
      estimatedTimeOfDeparture = _ref.estimatedTimeOfDeparture,
      timeZone = _ref.timeZone;
  // arrival values
  var deviationDuration;
  var sign = '+';
  var realDeparture = realTimeOfDeparture || estimatedTimeOfDeparture;

  if (realDeparture && scheduledTimeOfDeparture) {
    var departureDate = new Date(realDeparture);
    departureDate.setSeconds(0);
    departureDate.setMilliseconds(0);
    var scheduledDate = new Date(scheduledTimeOfDeparture);
    scheduledDate.setSeconds(0);
    scheduledDate.setMilliseconds(0);
    var departureDeviation = (departureDate.getTime() - scheduledDate.getTime()) / 60000;
    deviationDuration = (0, _constants.splitDuration)(Math.abs(departureDeviation)); // determine correct sign and color class

    if (departureDeviation < 0) {
      sign = '-';
    }

    if (departureDeviation > 0) {
      sign = '+';
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "block"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.departure"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-title"
    }, message);
  }), scheduledTimeOfDeparture && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.target"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), scheduledTimeOfDeparture && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: scheduledTimeOfDeparture,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), realTimeOfDeparture && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.actual"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), realTimeOfDeparture && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: realTimeOfDeparture,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), !realTimeOfDeparture && estimatedTimeOfDeparture && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.calculated"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), !realTimeOfDeparture && estimatedTimeOfDeparture && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: estimatedTimeOfDeparture,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: timeZone
  })), deviationDuration && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.tooltip.difference"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "block-label"
    }, message, ":");
  }), deviationDuration && /*#__PURE__*/_react["default"].createElement("span", {
    className: "deviation-departure"
  }, sign, deviationDuration.hours, "h ", deviationDuration.minutes, "min"));
};

exports.Departure = Departure;
Departure.propTypes = {
  scheduledTimeOfDeparture: _propTypes["default"].string,
  realTimeOfDeparture: _propTypes["default"].string,
  estimatedTimeOfDeparture: _propTypes["default"].string,
  timeZone: _propTypes["default"].string.isRequired
};
Departure.defaultProps = {
  scheduledTimeOfDeparture: null,
  realTimeOfDeparture: null,
  estimatedTimeOfDeparture: null
};
var _default = Departure;
exports["default"] = _default;